var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _path3, _path4, _line32, _path5, _line33, _path6, _line34, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path9, _line35, _line36, _circle8, _path10, _line37, _line38, _circle9, _path11, _line39, _line40, _path12, _line41, _line42, _path13, _line43, _line44, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeLongMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 40 C 130 35, 40 35, 0 35  L 0 165 C 40 165, 130 165, 200 160 Z",
    strokeWidth: 3,
    fill: "#aaa",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 44 C 130 39, 40 39, 0 39  L 0 161 C 40 161, 130 161, 200 156 Z",
    fill: "#955726"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 40,
    x2: 120,
    y2: 40,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 45,
    x2: 200,
    y2: 45,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 200,
    y2: 50,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 55,
    x2: 200,
    y2: 55,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 200,
    y2: 60,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 65,
    x2: 200,
    y2: 65,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70,
    x2: 200,
    y2: 70,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 75,
    x2: 200,
    y2: 75,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 200,
    y2: 80,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 85,
    x2: 200,
    y2: 85,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 90,
    x2: 200,
    y2: 90,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 95,
    x2: 200,
    y2: 95,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 200,
    y2: 100,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 105,
    x2: 200,
    y2: 105,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 110,
    x2: 200,
    y2: 110,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 115,
    x2: 200,
    y2: 115,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 120,
    x2: 200,
    y2: 120,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 125,
    x2: 200,
    y2: 125,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 130,
    x2: 200,
    y2: 130,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 135,
    x2: 200,
    y2: 135,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 140,
    x2: 200,
    y2: 140,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 145,
    x2: 200,
    y2: 145,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 200,
    y2: 150,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 155,
    x2: 200,
    y2: 155,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 120,
    y2: 160,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 43,
    x2: 180,
    y2: 157,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 41,
    x2: 150,
    y2: 159,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 40,
    x2: 120,
    y2: 160,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 38,
    x2: 90,
    y2: 162,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 38,
    x2: 60,
    y2: 162,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 38,
    x2: 30,
    y2: 162,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 70 L 195 72 L 195 128 L 160 130 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 80 L 185 80 L 185 90 L 195 90",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 85,
    x2: 235,
    y2: 85,
    stroke: "black",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 95 L 185 95 L 185 105 L 195 105",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 100,
    x2: 235,
    y2: 100,
    stroke: "black",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 110 L 185 110 L 185 120 L 195 120",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 115,
    x2: 235,
    y2: 115,
    stroke: "black",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 3 70 L 30 70 L 50 50 L 70 50 L 70 70 L 90 70 L 90 60 L 110 60 L 150 75 L 150 125 L 110 140 L 90 140 L 90 130 L 70 130 L 70 150 L 50 150 L 30 130 L 3 130 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 10 90 L 20 80 L 80 80 L 90 90 L 90 110 L 80 120 L 20 120 L 10 110 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 75,
    cy: 90,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 75,
    cy: 110,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 50,
    cy: 90,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 50,
    cy: 110,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 25,
    cy: 90,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 25,
    cy: 110,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 50,
    r: 20,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 38 L 65 40 L 65 60 L 45 62 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 48,
    x2: 72,
    y2: 48,
    stroke: "black",
    strokeWidth: 2.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 52,
    x2: 72,
    y2: 52,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 150,
    r: 20,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 162 L 65 160 L 65 140 L 45 138 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 152,
    x2: 72,
    y2: 152,
    stroke: "black",
    strokeWidth: 2.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 148,
    x2: 72,
    y2: 148,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 20,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 110 88 L 130 90 L 130 110 L 110 112 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 98,
    x2: 137,
    y2: 98,
    stroke: "black",
    strokeWidth: 2.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 102,
    x2: 137,
    y2: 102,
    stroke: "black",
    strokeWidth: 2.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 45 L 165 45 L 165 65 L 145 65 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 151.66,
    y1: 51.66,
    x2: 151.66,
    y2: 36.66,
    stroke: "black",
    strokeWidth: 2.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 158.33,
    y1: 51.66,
    x2: 158.33,
    y2: 36.66,
    stroke: "black",
    strokeWidth: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 155 L 165 155 L 165 135 L 145 135 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 151.66,
    y1: 148.33,
    x2: 151.66,
    y2: 162.33,
    stroke: "black",
    strokeWidth: 2.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 158.33,
    y1: 148.33,
    x2: 158.33,
    y2: 162.33,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 15,
    cy: 155,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 85,
    cy: 155,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 110,
    cy: 153,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 135,
    cy: 151,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 135,
    cy: 49,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 110,
    cy: 47,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 85,
    cy: 45,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 15,
    cy: 45,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLongMiddle);
export default __webpack_public_path__ + "static/media/ThreeLongMiddle.1e9e659a9a86ab7e7f84c4e4ade3aff0.svg";
export { ForwardRef as ReactComponent };